module.exports = __webpack_public_path__ + "img/ar04.ea92977a.jpg";